define('editor/edit/layers/edit/legendBase',['jquery', 'knockout', './layerBase', '../helpers', 'no-ui-slider', 'tinycolorpicker'], function ($, ko, layerBase, helper, noUiSlider) {
  var viewmodel = function (isExisting) {
    var self = this;

    if (isExisting) {
      self.layerBase = new layerBase();
      $.extend(self, self.layerBase);
    }

    self.content = ko.observable('');
    self.customLabel = ko.observable('');
    self.items = ko.observableArray([]);
    self.itemSize = ko.observable('small');
    self.detectedItems = ko.observableArray([]);
    self.icons = ko.observableArray([]);
    self.selectedItem = ko.observable(); // for new items
    self.selectedEditingItem = ko.observable(); // for editing icons
    self.iconColour = ko.observable('#FFFFFF');
    self.paddleColour = ko.observable('#000000');
    self.paddleVisible = ko.observable(true);
    self.polygonColour = ko.observable();
    self.polygonOpacity = ko.observable(100);
    self.polylineColour = ko.observable();
    self.polylineOpacity = ko.observable(100);

    self.editingItem = null;

    self.activate = function (editorMapId, layer, backToListFunc) {
      if (self.layerBase) {
        self.layerBase.activate(editorMapId, layer, backToListFunc);
      }
      self.editorMapId = editorMapId;
      if (layer) {
        self.layer = layer;
        self.items(layer.state().items());
        self.itemSize(layer.state().itemSize ? layer.state().itemSize() : self.itemSize());
      }
      helper.getIcons().then(function (icons) {
        self.icons(icons);
      });
      self.detectItems();
      self.showList();
    };

    self.detectItems = function () {
      helper.getMapLayers(self.editorMapId).then(function (layers) {
        self.detectedItems([]);
        self.detectMarkers(layers);
        self.detectPolylines(layers);
        self.detectPolygons(layers);
        self.detectBoundaries(layers);
      });
    };

    self.detectMarkers = function (layers) {
      var markers = ko.utils.arrayFilter(layers, function (layer) { return layer.type === 'Marker'; });
      ko.utils.arrayForEach(markers, function (marker) {
        var item = {
          text: marker.groupName ? marker.groupName : marker.name,
          isIcon: true,
          isSvg: marker.state.selectedicon.endsWith('.svg'),
          icon: marker.state.selectedicon,
          iconVisible: marker.state.visibilityOptions.iconVisible,
          iconColour: marker.state.iconColour,
          paddleColour: marker.state.paddleColour,
          paddleVisible: marker.state.visibilityOptions.paddleVisible,
          isPolygon: false,
          polygonColour: null,
          polygonOpacity: 0,
          isPolyline: false,
          polylineColour: null,
          polylineOpacity: 0,
          sortOrder: ko.observable(self.detectedItems().length)
        };

        if (item.isSvg) {
          item.html = self.getItemSvg(item);
        }

        var notInLegendAlready = !ko.utils.arrayFirst(self.items(), function (existing) {
          var legendItem = ko.toJS(existing);
          return legendItem.isIcon && legendItem.icon === item.icon;
        });

        var notInDetectedAlready = !ko.utils.arrayFirst(self.detectedItems(), function (detected) {
          return detected.isIcon && detected.icon === item.icon;
        });

        if (notInLegendAlready && notInDetectedAlready) {
          self.detectedItems.push(item);
        }
      });
    };

    self.getItemSvg = function (item) {
      var selectedicon = item.icon;
      var iconColour = item.iconColour;
      var paddleVisible = item.paddleVisible;
      var iconVisible = item.iconVisible;
      var paddleColour = item.paddleColour;
      var svg = '';
      var markerStyle = ';position: absolute;width: 29px;margin-left: -6px;margin-top: -1px;';
      var iconStyle = paddleVisible ? ';position: absolute;width: 16px;margin-top: 0px;margin-left: 1px;' : ';position: absolute;width: 24px;margin-top: 0px;margin-left: -4px;';

      if (paddleVisible) {
        svg += '<svg viewBox="0 0 32 32" style="fill:' + paddleColour + markerStyle + '">';
        svg += '<use xlink:href="/content/img/icons/marker.svg#Layer_1"></use>';
        svg += '</svg>';
      }

      if (iconVisible) {
          svg += '<svg viewBox="0 0 32 32" style="fill:' + iconColour + iconStyle + '">';
          svg += '<use xlink:href="' + selectedicon + '#Layer_1"></use>';
          svg += '</svg>';
      }

      return svg;
    };

    self.detectPolylines = function (layers) {
      var polylines = ko.utils.arrayFilter(layers, function (layer) { return layer.type === 'Polyline'; });
      ko.utils.arrayForEach(polylines, function (polyline) {
        var item = {
          text: polyline.groupName ? polyline.groupName : polyline.name,
          isIcon: false,
          icon: null,
          isPolygon: false,
          polygonColour: null,
          polygonOpacity: 0,
          isPolyline: true,
          polylineColour: polyline.state.properties.color,
          polylineOpacity: polyline.state.properties.opacity,
          sortOrder: ko.observable(self.detectedItems().length)
        };

        var notInLegendAlready = !ko.utils.arrayFirst(self.items(), function (existing) {
          var legendItem = ko.toJS(existing);
          return legendItem.isPolyline && legendItem.polylineColour === item.polylineColour;
        });

        var notInDetectedAlready = !ko.utils.arrayFirst(self.detectedItems(), function (detected) {
          return detected.isPolyline && detected.polylineColour === item.polylineColour;
        });

        if (notInLegendAlready && notInDetectedAlready) {
          self.detectedItems.push(item);
        }
      });
    };

    self.detectPolygons = function (layers) {
      var isPolygon = function (type) {
        return type === 'Polygon' || type === 'Circle' || type === 'Rectangle';
      };
      var polygons = ko.utils.arrayFilter(layers, function (layer) { return isPolygon(layer.type); });
      ko.utils.arrayForEach(polygons, function (polygon) {
        var item = {
          text: polygon.groupName ? polygon.groupName : polygon.name,
          isIcon: false,
          icon: null,
          isPolygon: true,
          polygonColour: polygon.state.properties.fillColor ? polygon.state.properties.fillColor : polygon.state.properties.color,
          polygonOpacity: polygon.state.properties.fillOpacity,
          isPolyline: false,
          polylineColour: null,
          polylineOpacity: 0,
          sortOrder: ko.observable(self.detectedItems().length)
        };

        var notInLegendAlready = !ko.utils.arrayFirst(self.items(), function (existing) {
          var legendItem = ko.toJS(existing);
            return legendItem.isPolygon && legendItem.polygonColour === item.polygonColour && legendItem.polygonOpacity === item.polygonOpacity;
        });

        var notInDetectedAlready = !ko.utils.arrayFirst(self.detectedItems(), function (detected) {
            return detected.isPolygon && detected.polygonColour === item.polygonColour && detected.polygonOpacity === item.polygonOpacity;
        });

        if (notInLegendAlready && notInDetectedAlready) {
          self.detectedItems.push(item);
        }
      });
    };

    self.detectBoundaries = function (layers) {
      var isBoundary = function (type) {
        return type === 'Boundary';
      };
      var boundaries = ko.utils.arrayFilter(layers, function (layer) { return isBoundary(layer.type); });
      ko.utils.arrayForEach(boundaries, function (boundary) {
        console.log(boundary);
        var item = {
          text: boundary.state.labelText,
          isIcon: false,
          icon: null,
          isPolygon: true,
          polygonColour: boundary.state.fillColor ? boundary.state.fillColor : boundary.state.color,
          polygonOpacity: boundary.state.fillOpacity,
          isPolyline: false,
          polylineColour: null,
          polylineOpacity: 0,
          sortOrder: ko.observable(self.detectedItems().length)
        };

        var notInLegendAlready = !ko.utils.arrayFirst(self.items(), function (existing) {
          var legendItem = ko.toJS(existing);
            return legendItem.isPolygon && legendItem.polygonColour === item.polygonColour && legendItem.polygonOpacity === item.polygonOpacity;
        });

        var notInDetectedAlready = !ko.utils.arrayFirst(self.detectedItems(), function (detected) {
            return detected.isPolygon && detected.polygonColour === item.polygonColour && detected.polygonOpacity === item.polygonOpacity;
        });

        if (notInLegendAlready && notInDetectedAlready) {
          self.detectedItems.push(item);
        }
      });
    };

    self.showList = function () {
      self.selectedEditingItem(null);
      self.editingItem = null;

      self.content({ view: 'editor/edit/layers/add/legend/list.html' });

      if (!self.editingItem) {
        setTimeout(function () {
          var options = {
            stop: function () {
              var sortedItems = [];
              var items = $('#legend-items.sortable .legend-item');
              for (var i = 0; i < items.length; i++) {
                var item = ko.dataFor(items[i]);
                item.sortOrder(i);
                sortedItems.push(item);
              }
              self.items(sortedItems);
            }
          };
          $("#legend-items.sortable").sortable(options);
          $("#legend-items.sortable").disableSelection();
        }, 500);
      }
    };

    self.editIcon = function (item) {
      self.editingItem = item;
      self.selectedItem(null);

      self.content({ view: 'editor/edit/layers/add/legend/type.html' });

      setTimeout(function () {
        self.initPlugins();
      }, 500);
    };

    self.chooseType = function () {
      self.content({ view: 'editor/edit/layers/add/legend/type.html' });
      self.paddleVisibleSubscription = self.paddleVisible.subscribe(function () {
        self.setSelectedItem(self.selectedItem());
      });
      setTimeout(function () {
        self.initPlugins();
      }, 500);
    };

    self.initPlugins = function () {
      setTimeout(function () {
        var sliderPolygonOpacity = $('.polygon-opacity'),
            sliderPolylineOpacity = $('.polyline-opacity'),
            sliderStart = +self.polygonOpacity(),
            iconColourPicker,paddleColourPicker,polygonColourPicker;
        if (sliderPolygonOpacity.length) {
            noUiSlider.create(sliderPolygonOpacity.get(0),
                {
                    start: sliderStart,
                    step: 1,
                    tooltips: true,
            connect: "lower",
            orientation: "horizontal",
            range: {
              'min': 0,
              'max': 100
            },
            serialization: {
              format: {
                decimals: 0
              }
            }
          });

          sliderPolygonOpacity.get(0).noUiSlider.on('change', function () {
                var newValue = sliderPolygonOpacity.get(0).noUiSlider.get();
                self.polygonOpacity(newValue);
                self.setSelectedPolygon();
          });
        }
        iconColourPicker = $('.color-picker-icon').tinycolorpicker();
        if (iconColourPicker.length) {
          iconColourPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.iconColour(newColour);
            self.setSelectedItem(self.selectedItem());
          });
        }

        paddleColourPicker = $('.color-picker-marker').tinycolorpicker();
        if (paddleColourPicker.length) {
          paddleColourPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.paddleColour(newColour);
            self.setSelectedItem(self.selectedItem());
          });
        }

        polygonColourPicker = $('.color-picker-polygon').tinycolorpicker();
        if (polygonColourPicker.length) {
          polygonColourPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.polygonColour(newColour);
            self.setSelectedPolygon();
          });
        }

        sliderStart = +self.polylineOpacity();
        var polylineColourPicker;
        if (sliderPolylineOpacity.length) {
            noUiSlider.create(sliderPolylineOpacity.get(0), {
                start: sliderStart,
                step: 1,
                tooltips: true,
            connect: "lower",
            orientation: "horizontal",
            range: {
              'min': 0,
              'max': 100
            },
            serialization: {
              format: {
                decimals: 0
              }
            }
          });

          sliderPolylineOpacity.get(0).noUiSlider.on('change', function () {
              var newValue = sliderPolylineOpacity.get(0).noUiSlider.get();
              self.polylineOpacity(newValue);
              self.setSelectedPolyline();
          });
        }
        polylineColourPicker = $('.color-picker-polyline').tinycolorpicker();
        if (polylineColourPicker.length) {
          polylineColourPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.polylineColour(newColour);
            self.setSelectedPolyline();
          });
        }
      }, 500);
    };

    self.createItem = function () {
      if (self.customLabel().length && self.selectedItem()) {
        var item = {
          text: ko.observable(self.customLabel()),
          isIcon: ko.observable(self.selectedItem().isIcon ? self.selectedItem().isIcon : false),
          isSvg: ko.observable(self.selectedItem().isIcon ? self.selectedItem().isSvg : false),
          icon: ko.observable(self.selectedItem().filePath),
          iconColour: ko.observable(self.iconColour()),
          paddleColour: ko.observable(self.paddleColour()),
          paddleVisible: ko.observable(self.paddleVisible()),
          isPolygon: ko.observable(self.selectedItem().isPolygon ? self.selectedItem().isPolygon : false),
          polygonColour: ko.observable(self.selectedItem().polygonColour),
          polygonOpacity: ko.observable(self.selectedItem().polygonOpacity),
          isPolyline: ko.observable(self.selectedItem().isPolyline ? self.selectedItem().isPolyline : false),
          polylineColour: ko.observable(self.selectedItem().polylineColour),
          polylineOpacity: ko.observable(self.selectedItem().polylineOpacity),
          sortOrder: ko.observable(self.items().length)
        };
        if (item.isSvg && item.isSvg()) {
          item.html = self.selectedItem().html;
        }
        self.items.push(item);
        self.selectedItem(0);
        self.customLabel('');
      }
    };

    self.addDetectedItem = function (detectedItem) {
      if (detectedItem) {
        var item = {
          text: ko.observable(detectedItem.text),
          isIcon: ko.observable(detectedItem.isIcon ? detectedItem.isIcon : false),
          isSvg: ko.observable(detectedItem.isIcon ? detectedItem.icon.endsWith('.svg') : false),
          icon: ko.observable(detectedItem.icon),
          iconColour: ko.observable(detectedItem.iconColour),
          paddleColour: ko.observable(detectedItem.paddleColour),
          paddleVisible: ko.observable(detectedItem.paddleVisible),
          html: ko.observable(detectedItem.html),
          isPolygon: ko.observable(detectedItem.isPolygon ? detectedItem.isPolygon : false),
          polygonColour: ko.observable(detectedItem.polygonColour),
          polygonOpacity: ko.observable(detectedItem.polygonOpacity),
          isPolyline: ko.observable(detectedItem.isPolyline ? detectedItem.isPolyline : false),
          polylineColour: ko.observable(detectedItem.polylineColour),
          polylineOpacity: ko.observable(detectedItem.polylineOpacity),
          sortOrder: ko.observable(self.items().length)
        };
        self.items.push(item);
        self.detectedItems.remove(detectedItem);
      }
    };

    self.deleteItem = function (item) {
      self.items.remove(item);
      self.detectItems();
    };

    self.selectType = function () {
      // update the item being edited, if any
      if (self.editingItem) {
        self.editingItem.isIcon(false);
        self.editingItem.isSvg(false);
        self.editingItem.isPolygon(false);
        self.editingItem.isPolyline(false);

        if (self.selectedEditingItem().isIcon) {
          self.editingItem.isIcon(true);
          self.editingItem.icon(self.selectedEditingItem().filePath);
          self.editingItem.isSvg(self.selectedEditingItem().filePath.endsWith('.svg'));
        }
        if (self.selectedEditingItem().isPolygon) {
          self.editingItem.isPolygon(true);
          self.editingItem.polygonColour(self.selectedEditingItem().polygonColour);
          self.editingItem.polygonOpacity(self.selectedEditingItem().polygonOpacity);
        }
        if (self.selectedEditingItem().isPolyline) {
          self.editingItem.isPolyline(true);
          self.editingItem.polylineColour(self.selectedEditingItem().polylineColour);
          self.editingItem.polylineOpacity(self.selectedEditingItem().polylineOpacity);
        }
      }
      self.paddleVisibleSubscription.dispose();

      self.showList();
    };

    self.setSelectedPolygon = function () {
      var item = {
        polygonColour: self.polygonColour(),
        polygonOpacity: self.polygonOpacity() / 100
      };

      self.setSelectedItem(item);
    };

    self.setSelectedPolyline = function () {
      var item = {
        polylineColour: self.polylineColour(),
        polylineOpacity: self.polylineOpacity() / 100
      };

      self.setSelectedItem(item);
    };

    self.setSelectedItem = function (item) {
      if (item.filePath) {
        var icon = {
          icon: item.filePath,
          iconColour: self.iconColour(),
          iconVisible: true,
          paddleVisible: self.paddleVisible(),
          paddleColour: self.paddleColour()
        };
        var isSvg = item.filePath.endsWith('.svg');
        if (self.editingItem) {
          self.selectedEditingItem({
            isIcon: true,
            isSvg: isSvg,
            html: self.getItemSvg(icon),
            filePath: item.filePath
          });
        } else {
          self.selectedItem({
            isIcon: true,
            isSvg: isSvg,
            html: self.getItemSvg(icon),
            filePath: item.filePath
          });
        }
      } else if (item.polygonColour) {
        if (self.editingItem) {
          self.selectedEditingItem({
            isPolygon: true,
            polygonColour: item.polygonColour,
            polygonOpacity: item.polygonOpacity
          });
        } else {
          self.selectedItem({
            isPolygon: true,
            polygonColour: item.polygonColour,
            polygonOpacity: item.polygonOpacity
          });
        }
      } else if (item.polylineColour) {
        if (self.editingItem) {
          self.selectedEditingItem({
            isPolyline: true,
            polylineColour: item.polylineColour,
            polylineOpacity: item.polylineOpacity
          });
        } else {
          self.selectedItem({
            isPolyline: true,
            polylineColour: item.polylineColour,
            polylineOpacity: item.polylineOpacity
          });
        }
      }
    };

    self.save = function () {
      self.createItem();
      self.layer.state().items(self.items());
      if (!self.layer.state().itemSize) {
        self.layer.state().itemSize = ko.observable('small');
      }
      self.layer.state().itemSize(self.itemSize());
      self.saveCommand();
    };

  };

  return viewmodel;
});

